import { combineReducers } from 'redux';
import billsReducer from './billsReducer';

const rootReducer = combineReducers({
  billsData: billsReducer,
});

export default rootReducer;